<div class="select-box-wrapper"
     [ngStyle]="{ 'width.px': width }"
>
    <button class="select-box"
        [matMenuTriggerFor]="menu"
        (menuClosed)="onMenuClosed()"
        (menuOpened)="onMenuOpened()"
         [ngClass]="{ 'active': isMenuOpened,
                      'not-empty': !useCircleIcon || !selectedItem.flagEmpty
         }"
    >
        <div class="select-box-content">
            @if (!useCircleIcon) {
              <div class="select-box-icon"
                   [ngClass]="{ mirrored: selectedItem.iconMirrored }"
              >
                <mat-icon>{{ selectedItem.icon }}</mat-icon>
              </div>
            } @else {
              <div class="select-box-circle"
                   [ngClass]="{ 'grey': selectedItem.flagEmpty,
                              'green': !selectedItem.flagEmpty
                  }"
              >
              </div>
            }
            <div class="select-box-title"
                 [ngClass]="{ 'grey': useCircleIcon && selectedItem.flagEmpty }"
                >
                @if (!selectedItem.flagEmpty || !selectedItem.emptyLabel) {
                  <span>{{ selectedItem.label }}</span>
                } @else if (selectedItem.flagEmpty) {
                  <span>{{ selectedItem.emptyLabel }}</span>
                }
            </div>
        </div>

        <div class="select-box-dropdown-icon"
             [ngClass]="{ 'grey': useCircleIcon && selectedItem.flagEmpty }"
             [attr.aria-label]="isMenuOpened? 'Close Menu' : 'Open Menu'"
            
        >
            @if (!isMenuOpened) {
              <mat-icon>expand_more</mat-icon>
            } @else {
              <mat-icon>expand_less</mat-icon>
            }
        </div>
    </button>

    <mat-menu #menu="matMenu" class="select-box-menu">
        @for (item of allItems; track $index) {
          <button mat-menu-item
                  [ngStyle]="{ 'width.px': width }"
                  (click)="onSelect(item)"
                  class="select-box-menu-item"
          >
            <mat-icon [ngClass]="{ mirrored: selectedItem.iconMirrored }"
            >
              {{ item.icon }}
            </mat-icon>
            {{ item.label }}
          </button>
        }
    </mat-menu>
</div>
